<mat-accordion [multi]="true" *ngIf="order && showInvoice">
  <div class="container-group">
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="summary-title">
          <h2>
            {{
              'myAccount.orderDetails.invoiceSummary.title'
                | cxTranslate : { num: filterInvoice(order?.consignments).length }
            }}
          </h2>
        </mat-panel-title>
        <mat-icon class="material-icons-sharp light material-icons mat-icon-no-color" role="img">expand_more</mat-icon>
      </mat-expansion-panel-header>
      <div class="summary-details">
        <ng-container *ngIf="filterInvoice(order?.consignments).length > 0">
          <button class="tertiary-btn view-pay-invoices" type="button" (click)="viewAndPayInvoices()">
            {{ 'myAccount.orderDetails.viewAndPayInvoices.title' | cxTranslate }}
          </button>
          <ng-container *ngFor="let con of filterInvoice(order.consignments)">
            <div class="invoice-entry" *ngIf="con?.invoice">
              <div class="referenceNumber">
                {{ con?.invoice?.referenceNumber }}
              </div>
              <div class="paymentStatus">
                <b>{{ con?.invoice?.paymentStatusDisplay }}</b
                >{{
                  con?.invoice?.paymentStatus !== '' && con?.invoice?.paymentStatus !== 'PAID'
                    ? ('myAccount.orderDetails.invoiceSummary.dueOn'
                      | cxTranslate : { date: con?.invoice?.date | date : 'dd/MM/yyyy' })
                    : ''
                }}
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="filterInvoice(order?.consignments).length === 0 && isCustomTranslationsEnabled !== null">
          {{
            'myAccount.orderDetails.invoiceSummary.empty'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled$,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          }}
        </ng-container>
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>
